export default __webpack_public_path__ + "static/media/chime3.50649320.mp3";